exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".repo-wrapper {\n    margin-left: 48px;\n    margin-right: 48px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/repository/top-repo/top-repo.component.css
// module id = 829
// module chunks = 0